import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { OwnershipType } from "@/types/domain";

interface OwnershipBadgeProps {
  ownership: OwnershipType;
  className?: string;
}

const COLORS = {
  positive: { backgroundColor: "#40C057", color: "white" },
  negative: { backgroundColor: "#FF646C", color: "white" },
  neutral: { backgroundColor: "#F59E0B", color: "white" },
} as const;

const ownershipConfig: Record<OwnershipType, { label: string; style: typeof COLORS[keyof typeof COLORS] }> = {
  public: { label: "Public", style: COLORS.positive },
  private: { label: "Private", style: COLORS.negative },
  institutional: { label: "Institutional", style: COLORS.negative },
  unknown: { label: "Unknown", style: COLORS.neutral },
};

export function OwnershipBadge({ ownership, className }: OwnershipBadgeProps) {
  const config = ownershipConfig[ownership];
  return (
    <Badge className={cn("border-transparent", className)} style={config.style}>
      {config.label}
    </Badge>
  );
}
